import React from "react";
import { Tooltip, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

const YesterdayShortcutTip = () => {
  const content = (
    <div style={{ maxWidth: 260 }}>
      ICBC data is usually one day behind.
      <br /><br />
      When enabled, report “To-Date” ranges (MTD, QTD, YTD)
      will end at <strong>yesterday</strong> instead of today.
    </div>
  );

  return (
    <Tooltip title={content} placement="right">
      <InfoCircleOutlined
        style={{
          color: "#1890ff",
          cursor: "pointer"
        }}
      />
    </Tooltip>
  );
};

export default YesterdayShortcutTip;
